

export const generateId = (length) => {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
    }
    return result;
}

const quantile = (arr, q) => {
    const asc = arr => arr.sort((a, b) => a - b);
    const sorted = asc(arr);
    const pos = (sorted.length - 1) * q;
    const base = Math.floor(pos);
    const rest = pos - base;
    if (sorted[base + 1] !== undefined) {
        return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
    } else {
        return sorted[base];
    }
};

export const ColorUtils = {
    getColor: function (value, noOfBreaks, colorRamp) {
        if (value === null) {
            return [0, 0, 0, 0];
        }
        try {
            colorRamp = colorRamp.map(v=>ColorUtils.hexToRgb(v+"ff"));
            const colorRampSize = colorRamp.length;
            const rampRatio = (1 / (colorRampSize - 1));
            const overAllRatio = value/noOfBreaks;
            const index = Math.floor(overAllRatio / rampRatio);
            const startColor = colorRamp[index];
            const endColor = (index + 1) >= colorRamp.length ? colorRamp[index] : colorRamp[index + 1];
            const startColorX = index * rampRatio;
            const endColorX = (index + 1) * rampRatio;
            const localRatio = (overAllRatio - startColorX) / (endColorX - startColorX);
            return ColorUtils.rgbToHex(...ColorUtils.getColorAtRatio(endColor, startColor, localRatio));
        } catch (e) {
            return [0, 0, 0, 0]
        }
    },
    getColorAtRatio: function (startColor, endColor, ratio) {
        const w = ratio * 2 - 1;
        const w1 = (w + 1) / 2;
        const w2 = 1 - w1;
        return [Math.round(startColor[0] * w1 + endColor[0] * w2),
            Math.round(startColor[1] * w1 + endColor[1] * w2),
            Math.round(startColor[2] * w1 + endColor[2] * w2),
            Math.round((startColor[3] * w1 + endColor[3] * w2))];
    },
    componentToHex: function(c) {
        const hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    },
    rgbToHex: function(r, g, b) {
        return "#" + ColorUtils.componentToHex(r) + ColorUtils.componentToHex(g) + ColorUtils.componentToHex(b);
    },
    hexToRgb: function(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        let rgba = result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
            a: parseInt(result[4], 16)
        } : null;
        if (!rgba)
            return rgba;
        return [rgba.r, rgba.g, rgba.b, rgba.a]
    }
}

export const calculatePercentiles = (percentiles, values) => {
    // return percentiles.map(p=>{
    //     return quantile(values, p);
    // })
    const asc = arr => arr.sort((a, b) => a - b);
    let l = percentiles.length;
    let arr = asc(values);
    return [
        arr[0], ...Array(l-2).fill(0).map((_, ix)=>{
            return arr[0] + (1 + ix) * (arr[arr.length-1] - arr[0])/l
        }), arr[arr.length-1]
    ]
}

export const calculateFieldStats = (baseWfsUrl, layerName, field) => {
    if(!field){
        console.log("No field")
        return new Promise((r)=>{r({percentiles:[], values: [], min:0, max: 1})})
    }
    let url = `${baseWfsUrl}?service=WFS&version=1.0.0&request=GetFeature&typeName=${layerName}&outputFormat=application%2Fjson&propertyName=${field}`;
    return new Promise((resolve) => {
        fetch(url)
        .then(r=>r.json())
        .then(data=>{
            let features = data.features;
            let values = features.map(feature => {
                return feature.properties[field]
            }).filter(e=>e!==null);
            return resolve({
                percentiles: [],
                values: values,
                min: Math.min(...values),
                max: Math.max(...values)
            })
        })
    })
    
}